export default __webpack_public_path__ + "alberta-clipboard.7084a88401b2df6e0140.svg";